/* AURIQ Concierge — vanilla widget.
 * Reads visitor_id + visitor_hmac from localStorage (populated by
 * auriq-tracker.js). Streams via SSE from /apps/.../concierge/stream/<jobId>.
 */
(function () {
  "use strict";
  var cfg = window.AuriqConfig;
  if (!cfg || !cfg.proxyUrl) return;

  var KEY_VID = "auriq_vid";
  var KEY_HMAC = "auriq_vhmac";
  function visitor() {
    try {
      var id = localStorage.getItem(KEY_VID);
      var h = localStorage.getItem(KEY_HMAC);
      return id && h ? { id: id, hmac: h } : null;
    } catch (e) { return null; }
  }

  function el(tag, css, text) {
    var e = document.createElement(tag);
    if (css) e.style.cssText = css;
    if (text != null) e.textContent = text;
    return e;
  }

  var ROOT_CSS = "position:fixed!important;right:16px!important;bottom:96px!important;width:340px!important;max-height:520px!important;background:#fff!important;border:1px solid #ddd!important;border-radius:10px!important;box-shadow:0 8px 24px rgba(0,0,0,.12)!important;font-family:Georgia,serif!important;color:#111!important;z-index:2147483647!important;display:flex!important;flex-direction:column!important;overflow:hidden!important;";
  var HEADER_CSS = "padding:12px 14px!important;border-bottom:1px solid #eee!important;font-weight:600!important;font-size:14px!important;color:#111!important;background:#fff!important;display:flex!important;justify-content:space-between!important;align-items:center!important;letter-spacing:0.06em!important;";
  var BODY_CSS = "flex:1!important;overflow-y:auto!important;padding:12px 14px!important;font-size:13px!important;line-height:1.5!important;color:#222!important;background:#fff!important;";
  var INTRO_CSS = "color:#555!important;font-size:12px!important;margin-bottom:8px!important;font-style:italic!important;";
  var FOOTER_CSS = "border-top:1px solid #eee!important;padding:8px!important;display:flex!important;gap:6px!important;background:#fff!important;";
  var INPUT_CSS = "flex:1!important;padding:8px 10px!important;border:1px solid #ccc!important;border-radius:4px!important;font:inherit!important;background:#fff!important;color:#111!important;outline:none!important;box-shadow:none!important;";
  var BTN_CSS = "padding:8px 14px!important;border:1px solid #222!important;background:#222!important;color:#fff!important;border-radius:4px!important;cursor:pointer!important;font:inherit!important;font-weight:500!important;";
  var CLOSE_BTN_CSS = "background:none!important;border:none!important;font-size:20px!important;line-height:1!important;color:#666!important;cursor:pointer!important;padding:0 4px!important;";
  var FAB_CSS = "position:fixed!important;right:16px!important;bottom:24px!important;background:#C5A059!important;color:#0d0d0d!important;border:none!important;border-radius:24px!important;padding:12px 18px!important;cursor:pointer!important;font-family:Georgia,serif!important;font-size:14px!important;font-weight:600!important;box-shadow:0 4px 16px rgba(197,160,89,.45)!important;z-index:2147483647!important;display:inline-block!important;visibility:visible!important;opacity:1!important;";
  var BUBBLE_USER = "display:inline-block!important;max-width:80%!important;padding:8px 12px!important;background:#222!important;color:#fff!important;border-radius:14px 14px 2px 14px!important;margin-bottom:6px!important;font-size:13px!important;line-height:1.4!important;";
  var BUBBLE_ASSIST = "display:inline-block!important;max-width:80%!important;padding:8px 12px!important;background:#f1f1f1!important;color:#222!important;border-radius:14px 14px 14px 2px!important;margin-bottom:6px!important;font-size:13px!important;line-height:1.4!important;";

  var widgetOpen = false;
  var root, bodyEl, inputEl, sendBtn, currentEs;

  function appendBubble(role, text) {
    var row = el("div", "text-align:" + (role === "user" ? "right" : "left") + ";");
    var b = el("span", role === "user" ? BUBBLE_USER : BUBBLE_ASSIST);
    b.textContent = text;
    row.appendChild(b);
    bodyEl.appendChild(row);
    bodyEl.scrollTop = bodyEl.scrollHeight;
    return b;
  }

  // Pull the live cart from the Shopify storefront. We send the raw payload
  // to dossier; the server picks the fields it actually uses and re-formats
  // before passing to the model.
  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  // Cache a compact catalog snapshot (title/handle/price/type/tags only) in
  // sessionStorage so the model can cross-recommend without us paying for a
  // full storefront fetch on every chat turn. Refreshes when the session
  // expires (browser-defined).
  var CATALOG_KEY = "auriq_concierge_catalog";

  function compactCatalog(products) {
    if (!Array.isArray(products)) return [];
    var out = [];
    for (var i = 0; i < products.length && out.length < 50; i++) {
      var p = products[i];
      if (!p || !p.title || !p.handle) continue;
      // Shopify /products.json prices are dollar-strings; convert to cents
      // so the dossier formatter doesn't have to parse two formats.
      var priceCents = null;
      if (typeof p.price === "number") {
        priceCents = p.price;
      } else if (typeof p.price === "string") {
        var parsed = parseFloat(p.price);
        if (isFinite(parsed)) priceCents = Math.round(parsed * 100);
      } else if (p.variants && p.variants[0] && p.variants[0].price) {
        var vp = parseFloat(p.variants[0].price);
        if (isFinite(vp)) priceCents = Math.round(vp * 100);
      }
      out.push({
        title: p.title,
        handle: p.handle,
        price: priceCents,
        product_type: p.product_type || null,
        tags: Array.isArray(p.tags) ? p.tags.slice(0, 8) : (typeof p.tags === "string" ? p.tags : null)
      });
    }
    return out;
  }

  function fetchCatalog() {
    var cached;
    try { cached = sessionStorage.getItem(CATALOG_KEY); } catch (e) { cached = null; }
    if (cached) return Promise.resolve(cached);
    return fetch("/products.json?limit=50", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.products)) return "";
        var compact = JSON.stringify(compactCatalog(data.products));
        try { sessionStorage.setItem(CATALOG_KEY, compact); } catch (e) {}
        return compact;
      })
      .catch(function () { return ""; });
  }

  // On a PDP, fetch the canonical product JSON so the model has authoritative
  // variants/prices/options instead of guessing. Returns "" on collection,
  // cart, or homepage. Handle parsing matches Shopify's URL shape:
  // /products/<handle>(/...)? possibly under a locale prefix.
  function fetchProduct() {
    if ((cfg.pageType || "") !== "product") return Promise.resolve("");
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve("");
    var handle = m[1];
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  function send() {
    var v = visitor();
    if (!v) { appendBubble("assistant", "Please refresh and try again."); return; }
    var text = inputEl.value.trim();
    if (!text) return;
    appendBubble("user", text);
    inputEl.value = "";
    sendBtn.disabled = true;

    Promise.all([fetchCart(), fetchProduct(), fetchCatalog()]).then(function (ctx) {
      var cartJson = ctx[0];
      var productJson = ctx[1];
      var catalogJson = ctx[2];
      return fetch(cfg.proxyUrl + "/concierge/start", {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          visitor_id: v.id,
          visitor_hmac: v.hmac,
          user_message: text,
          page_url: window.location.href,
          page_context: cfg.pageType || "",
          cart_json: cartJson || "",
          product_json: productJson || "",
          catalog_json: catalogJson || ""
        })
      });
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.blocked_reason || !data.job_id || !data.stream_token) {
          appendBubble("assistant", "Sorry — " + humanReason(data && data.blocked_reason));
          sendBtn.disabled = false;
          return;
        }
        streamJob(data.job_id, data.stream_token);
      })
      .catch(function () {
        appendBubble("assistant", "Connection error. Try again.");
        sendBtn.disabled = false;
      });
  }

  function humanReason(code) {
    switch (code) {
      case "RATE_LIMIT_VISITOR":
      case "RATE_LIMIT_IP":
        return "you've hit the chat limit. Try again later.";
      case "BUDGET_EXCEEDED":
        return "the concierge is paused for the day.";
      case "ABUSE_FLAGGED":
        return "we can't continue this conversation.";
      case "INJECTION_IGNORE_PREVIOUS":
      case "INJECTION_ROLE_HIJACK":
      case "INJECTION_PROMPT_LEAK":
      case "INJECTION_TEMPLATE":
      case "INJECTION_JAILBREAK":
      case "ABUSE":
        return "that message was blocked by our safety filter.";
      default:
        return "the concierge is unavailable right now.";
    }
  }

  function streamJob(jobId, streamToken) {
    var assistBubble = appendBubble("assistant", "");
    if (!streamToken) { assistBubble.textContent = "Please refresh and try again."; sendBtn.disabled = false; return; }
    // Same-origin fetch through the App Proxy. EventSource on the proxy (and
    // on the app origin) closes in ~8ms with an empty body, so the bubble hangs.
    var url = cfg.proxyUrl + "/concierge/stream/" + encodeURIComponent(jobId)
      + "?stream_token=" + encodeURIComponent(streamToken);
    var watchdog = setTimeout(function () {
      if (!assistBubble.textContent) {
        assistBubble.textContent = "Sorry — the stylist didn't respond. Try again.";
      }
      sendBtn.disabled = false;
    }, 25000);
    fetch(url, { credentials: "include" })
      .then(function (r) { return r.text(); })
      .then(function (raw) {
        clearTimeout(watchdog);
        var parts = String(raw).split("\n");
        for (var i = 0; i < parts.length; i++) {
          var line = parts[i];
          if (line.indexOf("data:") !== 0) continue;
          try {
            var d = JSON.parse(line.slice(5).trim());
            if (d.text) {
              assistBubble.textContent += d.text;
              bodyEl.scrollTop = bodyEl.scrollHeight;
            }
          } catch (e) {}
        }
        if (!assistBubble.textContent) {
          assistBubble.textContent = "Sorry — the stylist is unavailable right now.";
        }
        sendBtn.disabled = false;
      })
      .catch(function () {
        clearTimeout(watchdog);
        if (!assistBubble.textContent) {
          assistBubble.textContent = "Sorry — the stylist is unavailable right now.";
        }
        sendBtn.disabled = false;
      });
  }

  function buildRoot() {
    root = el("div", ROOT_CSS);
    var header = el("div", HEADER_CSS);
    var title = el("span", "color:#111!important;font-weight:600!important;font-size:14px!important;letter-spacing:0.08em!important;", "AURIQ CONCIERGE");
    header.appendChild(title);
    var close = el("button", CLOSE_BTN_CSS, "×");
    close.onclick = hide;
    header.appendChild(close);
    bodyEl = el("div", BODY_CSS);
    bodyEl.appendChild(el("div", INTRO_CSS,
      "Ask about styles, sizing, materials, or order status."));
    var footer = el("div", FOOTER_CSS);
    inputEl = el("input", INPUT_CSS);
    inputEl.type = "text";
    inputEl.placeholder = "Type a message…";
    inputEl.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });
    sendBtn = el("button", BTN_CSS, "Send");
    sendBtn.onclick = send;
    footer.appendChild(inputEl);
    footer.appendChild(sendBtn);
    root.appendChild(header);
    root.appendChild(bodyEl);
    root.appendChild(footer);
  }

  function show() {
    if (widgetOpen) return;
    if (!root) buildRoot();
    document.body.appendChild(root);
    widgetOpen = true;
    setTimeout(function () { if (inputEl) inputEl.focus(); }, 30);
    var fab = document.getElementById("auriq-concierge-fab");
    if (fab) fab.style.display = "none";
  }
  function hide() {
    if (!widgetOpen) return;
    try { root.remove(); } catch (e) {}
    widgetOpen = false;
    if (currentEs) { try { currentEs.close(); } catch (e) {} currentEs = null; }
    showFab();
  }

  function showFab() {
    if (document.getElementById("auriq-concierge-fab")) return;
    var fab = el("button", FAB_CSS, "Chat with stylist");
    fab.id = "auriq-concierge-fab";
    fab.onclick = show;
    document.body.appendChild(fab);
  }

  // ---- bootstrap on availability check (called from tracker) ---------
  window.Auriq = window.Auriq || {};
  window.Auriq.concierge = {
    init: function () {
      var v = visitor();
      if (!v) return;
      fetch(cfg.proxyUrl + "/concierge/availability", {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visitor_id: v.id, visitor_hmac: v.hmac })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          showFab();
          if (data && data.mode === "proactive") setTimeout(show, 5000);
        })
        .catch(function () { showFab(); });
    },
    open: show,
    close: hide
  };

  (function waitForVisitor(n) {
    if (visitor()) {
      try { window.Auriq.concierge.init(); } catch (e) {}
      return;
    }
    if (n < 40) setTimeout(function () { waitForVisitor(n + 1); }, 250);
    else showFab();
  })(0);
})();
